import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.modal.item,
      padding: spacing.m,
      borderRadius: constants.radius.card,
      justifyContent: "space-between",
    },
    title: {
      flex: 1,
    },
    error: {
      color: theme.input.error,
    },
  };

  return styles;
};
